import classNames from "classnames";
import SVGError from "../../icons/Error.svg?react";
import styles from "./ErrorText.module.css";
import Icon from "./Icon";

interface Props {
  text: string;
  className?: string;
}

const ErrorText = ({ text, className }: Props) => (
  <span className={classNames(styles.text, className)} title={text}>
    <Icon glyph={SVGError} className={styles.icon} /> {text}
  </span>
);

export default ErrorText;
